import {AddressDetails, Coordinate} from '@hconnect/tuc-processes/shipToCreation'
import {api} from '../../../App.global'
import {useQuery, UseQueryResult} from 'react-query'
import {ADDRESS_QUERY_STALE_TIME_MS} from '../constants'

export type ReverseGeoCodeParams = {
  country: string
  latitude?: number
  longitude?: number
}

export type ReverseGeoCodeResponse = {
  addresses: {location: Coordinate; address: AddressDetails}[]
}

export const reverseGeoCode = async (
  params: ReverseGeoCodeParams
): Promise<ReverseGeoCodeResponse> => {
  const config = {params}
  const response = await api.get('/address/reverse-geocode', config)
  const {data} = response
  return data
}

export const useReverseGeoCode = (
  params: ReverseGeoCodeParams
): UseQueryResult<ReverseGeoCodeResponse, Error> => {
  const queryInfo = useQuery<ReverseGeoCodeResponse, Error>({
    queryKey: [
      'reverseGeoCode',
      {
        ...params
      }
    ],
    queryFn: () => reverseGeoCode(params),
    staleTime: ADDRESS_QUERY_STALE_TIME_MS,
    cacheTime: ADDRESS_QUERY_STALE_TIME_MS,
    enabled: !!params.latitude && !!params.longitude
  })
  return queryInfo
}
